import { useEffect, useRef } from "react";

interface UseDocumentCleanupProps {
  uploadTextUrl: string | null | undefined;
}

export function useDocumentCleanup({ uploadTextUrl }: UseDocumentCleanupProps): void {
  // Keep a ref so the stable event listener always reads the current URL
  // without needing to re-register on every URL change.
  const uploadTextUrlRef = useRef(uploadTextUrl);
  useEffect(() => {
    uploadTextUrlRef.current = uploadTextUrl;
  }, [uploadTextUrl]);

  useEffect(() => {
    const handleCleanup = () => {
      const url = uploadTextUrlRef.current;
      if (url != null) {
        // PUT with empty body signals the server to clear the stored document text.
        // keepalive ensures the request completes even after the page unloads.
        fetch(url, {
          method: "PUT",
          body: "",
          keepalive: true,
          headers: { "Content-Type": "text/plain" },
        }).catch((err) => {
          console.error("Failed to clear document text on unload:", err);
        });
      }
    };

    window.addEventListener("beforeunload", handleCleanup);
    return () => {
      window.removeEventListener("beforeunload", handleCleanup);
    };
    // Empty deps: register once, rely on ref for current URL value.
  }, []);
}
